import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '../shared/services/app.service';
import { RolePermissionService } from '../shared/services/role-permission.service';

@Pipe({
    name: 'decimalCurrency',
    standalone: false
})
export class DecimalCurrencyPipe implements PipeTransform {
  constructor(
    private rolePermission:RolePermissionService,
    private appService: AppService
) { }

  transform(value: number | string): any {
    return this.rolePermission.checkdecimalConfig() ? (value + "." +('0'.repeat(this.appService._currentSessionData.currency_decimal_limit))) : value;
  }

}
// This pipe formats a number or string to a decimal currency format based on user permissions.
// It appends ".00" to the value if the user has permission to see decimal values